import React from 'react';
import { Rating as MuiRating, styled } from '@mui/material';
import { Colors } from 'library';

type RatingSize = 'small' | 'medium' | 'large';

interface RatingProps {
    value?: number | null;
    onChange?: (value: number | null) => void;
    readOnly?: boolean;
    size?: RatingSize;
    precision?: number;
    max?: number;
    color?: string;
}

const STAR_GOLD = '#FAAF00';

export function Rating({
    value = null,
    onChange,
    readOnly,
    size = 'medium',
    precision,
    max = 5,
    color = STAR_GOLD,
}: RatingProps) {
    return (
        <StyledRating
            value={value}
            onChange={onChange ? (_event, val) => onChange(val) : undefined}
            readOnly={readOnly}
            size={size}
            precision={precision}
            max={max}
            $filled={color}
        />
    );
}

const StyledRating = styled(MuiRating, { shouldForwardProp: (prop) => prop !== '$filled' })<{ $filled: string }>(
    ({ $filled }) => ({
        color: $filled,
        '& .MuiRating-iconEmpty': {
            color: Colors.border,
        },
    }),
);
